import React, { Component } from 'react';

import { IconValueList } from '../../molecules';
import { Text, Line, MaterialIcon } from '../../atoms';
import { sideBarOptions } from '../../models';

export class Collapsible extends Component {

	renderItems(items) {
		return items.labels.map((item, i) => 
			<LabelWithColor label={items.labels[i]} style={{backgroundColor: items.colors[i]}}/>
		);
	}


	render() {
		return (
			<ul className="collapsible item" data-collapsible="accordion">
				<li>
					<div className="collapsible-header item-container-header">
						<h4 className="title">{this.props.label}</h4>
						<div className="header-items flex -sb">
							{this.renderItems(this.props.items)}
						</div>
					</div>
					<div className="collapsible-body">
						<div className="fex -c -al-c">
							<span>VIZUALIZAR GRÁFICO</span>
						</div>
						{this.props.canvas}
					</div>
				</li>
			</ul>
		);
	}
}


// WEBPACK FOOTER //
// src/components/common/Collapsible.js